// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"5c2e0996","142":"4f0f0c89","310":"68bb8d65","368":"0c288941","414":"aa07f569","453":"8f06eed8","539":"c2aed0d9","557":"fe6a40b1","656":"8fd8e9b6","803":"c462871a","902":"00c1eae6","939":"d9e261a4","957":"c8d6aa5c","965":"7c952329"}[chunkId] + ".chunk.js";
};